var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AbstractFrontgateConnection, ConnectionState } from './AbstractFrontgateConnection';
import { Encoding } from './util/Encoding';
import WebSocket from 'isomorphic-ws';
var FrontgateWSConnection = (function (_super) {
    __extends(FrontgateWSConnection, _super);
    function FrontgateWSConnection(auth, options) {
        var _this = this;
        if (typeof (WebSocket) === 'undefined') {
            throw new Error('WebSocketClient not supported, WebSocket() missing in JavaScript environment');
        }
        options = FrontgateWSConnection.sanitizeOptions(options);
        var opts = Object.assign({}, FrontgateWSConnection.DEFAULT_WS_OPTIONS, options);
        _this = _super.call(this, auth, opts) || this;
        _this.ws = null;
        var encoding = _this.options.encoding;
        if (!Encoding.isSupportedEncoding(encoding)) {
            throw new Error("Unknown or unsupported encoding: " + encoding);
        }
        _this.onReceiveTimeout = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace('onReceiveTimeout: Closing connection');
                        return [4, _super.prototype.close.call(this)];
                    case 1:
                        _a.sent();
                        this.ws.close();
                        return [2];
                }
            });
        }); };
        return _this;
    }
    FrontgateWSConnection.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        (function () { return __awaiter(_this, void 0, void 0, function () {
                            var openWebSocketError_1, authError_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (this.isInitialized()) {
                                            return [2, reject(new Error('Connection is already initialized'))];
                                        }
                                        if (this.isAuthenticated()) {
                                            return [2, reject(new Error('Connection is already open'))];
                                        }
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4, this.openWebSocket()];
                                    case 2:
                                        _a.sent();
                                        return [3, 4];
                                    case 3:
                                        openWebSocketError_1 = _a.sent();
                                        this.logger.error('Problem opening connection', openWebSocketError_1);
                                        return [2, reject(new Error(openWebSocketError_1.message))];
                                    case 4:
                                        this.ws.onclose = this.handleClose.bind(this);
                                        this.ws.onerror = this.handleWsError.bind(this);
                                        _a.label = 5;
                                    case 5:
                                        _a.trys.push([5, 7, , 8]);
                                        return [4, this.auth.authenticate(this)];
                                    case 6:
                                        _a.sent();
                                        return [3, 8];
                                    case 7:
                                        authError_1 = _a.sent();
                                        this.logger.error('Authentication problem occurred', authError_1);
                                        return [2, reject(new Error(authError_1.message))];
                                    case 8:
                                        resolve();
                                        return [2];
                                }
                            });
                        }); })();
                    })];
            });
        });
    };
    FrontgateWSConnection.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.trace('Closing connection explicitly');
                        this.options.shouldReconnectOnConnectionLoss = false;
                        return [4, _super.prototype.close.call(this)];
                    case 1:
                        _a.sent();
                        this.ws.close();
                        return [2];
                }
            });
        });
    };
    FrontgateWSConnection.prototype.send = function (msg) {
        var idJob = this.preSubmit(msg);
        var promise = this.submit(msg)
            .then(function (resultMsg) {
            return resultMsg;
        });
        promise.idJob = idJob;
        return promise;
    };
    FrontgateWSConnection.prototype.submit = function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            var _this = this;
            return __generator(this, function (_a) {
                this.timestampOfLastMessageSent = Date.now();
                promise = new Promise(function (resolve) {
                    _this.logger.debug("Sending " + msg.Message, { request: msg });
                    _this.sendMessage(msg);
                    _this.resolveOnMessage = resolve;
                    switch (msg.Message) {
                        case 'Foundation::DisconnectionMessage':
                            resolve(undefined);
                            break;
                        case 'Foundation::KeepAliveMessage':
                            resolve(undefined);
                            break;
                        case 'Foundation::PingRequest':
                            resolve(undefined);
                            break;
                    }
                });
                promise
                    .catch(function (submitError) {
                    var lastMsgDate = new Date(_this.timestampOfLastMessageSent);
                    _this.logger.error("Failed sending " + msg.Message, submitError, { request: msg, lastMsgDate: lastMsgDate });
                });
                return [2, promise];
            });
        });
    };
    FrontgateWSConnection.prototype.sendMessage = function (msg) {
        var data = JSON.stringify(msg);
        if (Encoding.isCompressedJson(this.options.encoding)) {
            data = this.compressor.compress(data);
        }
        this.ws.send(data);
    };
    FrontgateWSConnection.prototype.openWebSocket = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.logger.debug('Open WebSocket');
                return [2, new Promise(function (resolve, reject) {
                        var encoding = _this.options.encoding;
                        var wsProtocol = _this.options.tls ? 'wss' : 'ws';
                        var wsUrl = wsProtocol + "://" + _this.options.host + ":" + _this.options.port + _this.options.path_prefix + "/ws";
                        var _a = encoding.split('-'), protocolVersion = _a[0], protocolType = _a[1];
                        var protocolPrefix = protocolType ? protocolType + "." : '';
                        var subProtocols = [protocolPrefix + "ws-" + protocolVersion + ".mdgms.com"];
                        if (_this.options.split_authentication_token_second_factor) {
                            subProtocols.push("mdg2auth-" + _this.options.split_authentication_token_second_factor);
                        }
                        if (_this.options.webSocketClientOptions) {
                            _this.ws = new WebSocket(wsUrl, subProtocols, _this.options.webSocketClientOptions);
                        }
                        else {
                            _this.ws = new WebSocket(wsUrl, subProtocols);
                        }
                        _this.ws.binaryType = 'arraybuffer';
                        _this.state = ConnectionState.CONNECTING;
                        _this.ws.onopen = function () {
                            _this.logger.info('WebSocket connected', { wsUrl: wsUrl, subProtocols: subProtocols });
                            resolve();
                        };
                        var errorFunction = function (err) {
                            _this.state = ConnectionState.DISCONNECTED;
                            reject(err);
                        };
                        _this.ws.onclose = reject;
                        _this.ws.onerror = errorFunction;
                        _this.ws.onmessage = _this.onWebSocketMessage.bind(_this);
                    })];
            });
        });
    };
    FrontgateWSConnection.prototype.onWebSocketMessage = function (e) {
        if (this.state === ConnectionState.DISCONNECTED) {
            return;
        }
        var decodedMessage = this.decodeMessage(e.data);
        var msg = this.handleMessage(decodedMessage);
        this.logger.debug("Received " + decodedMessage.Message, decodedMessage);
        if (this.resolveOnMessage && msg) {
            this.resolveOnMessage(msg);
        }
    };
    FrontgateWSConnection.prototype.decodeMessage = function (msg) {
        var encoding = this.options.encoding;
        try {
            if (msg instanceof ArrayBuffer && Encoding.isCompressedJson(encoding)) {
                var decoded = this.compressor.decompress(new Uint8Array(msg));
                return JSON.parse(decoded);
            }
            if (typeof msg === 'string' && Encoding.isPlainJson(encoding)) {
                return JSON.parse(msg);
            }
        }
        catch (decodeMessageError) {
            this.logger.error('Decoding message failed', decodeMessageError);
        }
        if (String(msg.constructor.name) === 'Buffer') {
            return msg;
        }
        this.logger.error("Could not decode Message of type \"" + typeof (msg) + "\" with encoding \"" + encoding + "\".");
    };
    FrontgateWSConnection.sanitizeOptions = function (options) {
        if (options === void 0) { options = {}; }
        if (options.frontgateHost) {
            options.host = options.frontgateHost;
        }
        if (options.frontgatePathPrefix) {
            options.path_prefix = options.frontgatePathPrefix;
        }
        if (options.frontgateSplitAuthenticationTokenSecondFactor) {
            options.split_authentication_token_second_factor = options.frontgateSplitAuthenticationTokenSecondFactor;
        }
        if (options.frontgateWebsocketProtocol) {
            options.encoding = options.frontgateWebsocketProtocol;
        }
        if (options.deploymentStage) {
            options.deployment_stage = options.deploymentStage;
        }
        return options;
    };
    FrontgateWSConnection.DEFAULT_WS_OPTIONS = {
        encoding: 'jsjsonc-v2',
        path_prefix: '',
        tls: true
    };
    return FrontgateWSConnection;
}(AbstractFrontgateConnection));
export { FrontgateWSConnection };
//# sourceMappingURL=FrontgateWSConnection.js.map